interface learnMemeProps {
    img?: string;
    msg?: string;
}

export const LearnMeme: React.FC<learnMemeProps> = ({ img = "", msg = "" }) => {
    return (
        <div className="flex flex-row items-center h-48 py-6 pl-6 pr-4">
            <div className="mr-5 h-36 w-28">
                {img ? (
                    <img
                        alt="meme"
                        src={img}
                        className="object-contain w-full h-full"
                    />
                ) : (
                    <div className="w-full h-full bg-gray-300" />
                )}
            </div>
            <span
                className="text-xl font-light text-black "
                dangerouslySetInnerHTML={{ __html: msg }}
            />
        </div>
    );
};
